var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramDebtConsolidation64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./DebtConsolidation64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Debt-consolidation",
    transform: "translate(9.000000, 15.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,26.6944444 C46,29.0943611 44.2432759,31 42.0344828,31 L3.96551724,31 C1.75672414,31 0,29.0943611 0,26.6944444 L0,4.30555556 C0,1.90736111 1.75672414,0 3.96551724,0 L42.0344828,0 C44.2432759,0 46,1.90736111 46,4.30555556 L46,26.6944444 L46,26.6944444 Z",
    id: "Stroke-1",
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,8 L7,8",
    id: "Top"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,14 L20,14",
    id: "Bottom"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(27.000000, 18.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    cx: 8,
    cy: 8,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(32.000000, 15.000000)",
    fill: "#FFCC00"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(38.000000, 18.510000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.546875,8.88671875 L4.01193835,8.88671875 M3.64583333,5.46875 L2.91666667,5.46875 M2.55056165,2.05078125 L6.015625,2.05078125",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91666667,2.05078125 C1.90989759,2.05078125 1.09375,2.81591962 1.09375,3.75976562 C1.09375,4.70361163 1.90989759,5.46875 2.91666667,5.46875 L2.91666667,5.46875",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46875,5.46875 C4.46198092,5.46875 3.64583333,6.23388837 3.64583333,7.17773438 C3.64583333,8.12158038 4.46198092,8.88671875 5.46875,8.88671875",
    id: "Curve-bottom",
    transform: "translate(4.557292, 7.177734) scale(-1, 1) translate(-4.557292, -7.177734) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28125,2.05078125 L3.28125,0",
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28125,10.9375 L3.28125,8.88671875",
    id: "Stick-bottom"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramDebtConsolidation64);
export default __webpack_public_path__ + "static/media/pictogramDebtConsolidation64.59bef411df7c8de1cd3a0507c746c646.svg";
export { ForwardRef as ReactComponent };